import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './DropshipProductCard.module.scss';
import Checkbox from '../Checkbox';
import ProductImagesSlider from '../ProductImagesSlider';
import { shortTitle } from '../../../utils/textHelper';
import { useRetailerType } from '../../../hooks/useRetailerType';
import Price from '../Price';
import { getProductPriceRangeForRetailerProductsListUi } from '../../../utils/pricings';
import { dropshipProductsUtils } from '../../../utils/dropship-products';
import { NO_VALUE_PLACEHOLDER } from '../../../constants/tables';
import { humanize } from '../../../utils/humanize';
import { sumBy } from 'lodash';
function DropshipProductCard(props) {
  const { product, approvedStatus, params = '', checked = false } = props;

  const { priceType } = useRetailerType();

  const card = useRef(null);

  const handleCheck = (e) => {
    e.preventDefault();
    const checkedPayload = {
      model: product.model,
      variants: product.variants,
    };
    props.onCheck(!checked, checkedPayload);
  };

  const openApproved = (e) => {
    props.open(product);
    e.stopPropagation();
  };

  if (!product) {
    return null;
  }

  const renderPriceData = () => {
    const productPriceData = getProductPriceRangeForRetailerProductsListUi({
      variants: product.variants,
      retailerMandatoryCurrency: product.variants[0]?.priceData?.currency,
    });

    if (!productPriceData) return NO_VALUE_PLACEHOLDER;

    if (product.variants.length > 1 && productPriceData.range?.[priceType]) {
      return (
        <Price
          min={productPriceData.range[priceType].min}
          max={productPriceData.range[priceType].max}
          currency={productPriceData.currency}
        />
      );
    }

    return (
      <Price max={productPriceData[priceType]} min={productPriceData[priceType]} currency={productPriceData.currency} />
    );
  };

  const renderInventoryInfo = () => {
    const inventoryAmountToRender = sumBy(product.variants, 'available_inventory');
    return (
      <p>
        {inventoryAmountToRender} units - {product.variants.length} variants
      </p>
    );
  };

  const showSlider = props.slider && product.square_images.length > 1;
  const showApprovedButton = props.modal && product.retailer_approved_variants_count > 0;
  const productLink = dropshipProductsUtils.getCatalogueManagementProductUrl({
    retailerId: props.retailerId,
    model: product.model,
    params,
  });

  return (
    <div className={styles.resultsProduct} onClick={handleCheck} ref={card}>
      <div className={styles.wrapper}>
        <div className={styles.wp}>
          <div className={styles.top}>
            {props.checkbox && (
              <div>
                <Checkbox checked={checked} value={product.model} hideLabel />
              </div>
            )}

            {showApprovedButton && (
              <button className={styles.approve_button} onClick={openApproved}>
                Approved
              </button>
            )}

            {approvedStatus && <p className={styles.approve_button}>{humanize(approvedStatus)}</p>}
          </div>
          <div className={styles.img_block}>
            {showSlider ? (
              <ProductImagesSlider images={product.square_images} cardRef={card} />
            ) : (
              <img alt="" src={product.square_images[0]} />
            )}
          </div>
          <div className={styles.desc}>
            <p className={styles.pt}>
              <Link to={productLink}>{shortTitle(product.title)}</Link>
            </p>
          </div>
        </div>
        <div className={styles.details}>
          <p>Model: {product.model}</p>
          {renderInventoryInfo()}
          {renderPriceData()}
        </div>
      </div>
    </div>
  );
}

export default DropshipProductCard;

DropshipProductCard.propTypes = {
  product: PropTypes.shape({
    images: PropTypes.array,
    variants: PropTypes.array,
    model: PropTypes.string,
    retailer_approved_variants_count: PropTypes.number,
    available_inventory: PropTypes.number,
  }).isRequired,
  checkbox: PropTypes.bool,
  onCheck: PropTypes.func,
  checked: PropTypes.bool,
  modal: PropTypes.bool,
  open: PropTypes.func,
  slider: PropTypes.bool,
  params: PropTypes.string,
  retailerId: PropTypes.number.isRequired,
};
